query TravelAuthorizationAvailableDocumentTypes($isDocumentUpload: Boolean) {
  travelAuthorizationAvailableDocumentTypes(
    isDocumentUpload: $isDocumentUpload
  ) {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
    }
  }
}
